<template>
  <router-link :to="{path:'/OrganDetails', query:{id:organItem.id}}"  target="" class="organ-item">
    <div class="pic">
      <img :src="organItem.imagesPath" alt='易极云课堂'>
    </div>
    <h4 class="item-name">{{ organItem.name  | ellipsis}}</h4>
    <p class="item-msg">{{ organItem.description }}</p>
    <!--<i class="organ">{{ organItem.orgTypeName }}</i>-->
    <i class="organ">{{ organItem.orgTypeNameList.slice(0,3).toString() }}</i>
  </router-link>
</template>

<script>
export default {
  props: {
    organItem: {
      type: Object,
      default: function () {
        return {
          headerImgPath: 'static/img/organ.png',
          imagesPath: 'static/img/organ.png',
          name: '阿里巴巴',
          description: 'hahahahahahhahahahahahhahahahahahhahahahahahhahahahahahhahahahahah',
          orgTypeName: '大学',
          id: '0'
        }
      }
    }
  },
  filters:{
    ellipsis:function(value) {
      if (!value) return ''
      if (value.length > 24) {
        return value.slice(0,24) + '...'
      }
      return value
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/scss" lang="scss" scoped>
  @import '~@/styles/base.scss';
  .organ-item {
    position: relative;
    display: block;
    height: 320px;
    background-color: #fff;
    box-shadow: 0 2px 4px #eee;
    .pic {
      height: 145px;
      width: 100%;
      overflow: hidden;
    }
    img {
      width: 100%;
      height: 145px;
    }
    .item-name {
      font-size: 18px;
      // font-weight: 600;
      margin: 20px 0 0 20px;
      height: 60px;
      line-height: 30px;
      font-family: "microsoft yahei",Arial, Helvetica, sans-serif;
      color: $grayColor;
    }
    .item-msg {
      max-width: 238px;
      overflow: hidden;
      margin: 10px 0 0 20px;
      font-size: 16px;
      line-height: 1em;
      color: $recommendOrganMsg;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .organ {
      position: absolute;
      bottom: 20px;
      right: 20px;
      display: block;
      /*width: 80px;*/
      width: auto;
      padding: 0px 20px;
      height: 24px;
      border-radius: 12px;
      text-align: center;
      color: #fff;
      line-height: 24px;
      font-size: 14px;
      background: $organColor;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/organ-item/organ-item.vue